export class ScheduleEventEmitterBo {
    isCreate: boolean = false;
    isClose: boolean = false;
    ClientDropdown: any = [];
    CustomFrequencyList: any = [];
}
export class GetScheduleBo {
    orderColumn: string = "clientName";
    orderType: string = "asc";
    type: string = "string";
    field: string = "clientName";
    operator: string = "startswith";
    value: string = "";
    matchCase: boolean = false;
    fromDate: string | null;
    toDate: string | null;
    clientId: string | null;
    employeeId: string | null;
    locationId: string | null;
    currentpageno: number = 1;
    pageitem: number = 10;
    startDate: string;
    endDate: string;
    serviceGroupId: string | null;
}
export class SaveVisitScheduleBO {
    id: string | null;
    employeeId: string;
    clientId: string;
    serviceGroupId: string;
    startDate: string | null = "";
    endDate: string | null = "";
    customFrequencyLid: string;
    startTime: string | null = "";
    endTime: string | null = "";
    showDays: boolean = false;
    serviceGroup: any = [];
    appointmentDays: string[];
    FrequencyDays: any = [];
    serviceId: string;
}
export class UpdateAppointmentUpdateBO {
    appointmentId: string;
    startTime: string;
    endTime: string;
    employeeId: string;
    clientId: string;
    serviceGroupId: string;
    startDate: string | null = "";
    endDate: string | null = "";
    customFrequencyLid: string;
    appointmentDays: any[];
    updateEmployeeId: string;
    updateClientId: string;
    updateServiceGroupId: string;
    serviceGroupName: string;
    updateStartDate: string;
    updateEndDate: string;
    frequencyDays: string;
    updateCustomFrequencyLid: string;
    serviceId: string;
}
export class clientDetails {
    weekStart: any;
    weekEnd: any;
    clientLocation: any;
}

export class functionpermission {
    ScheduleCreate: boolean = true;
    ScheduleUpdate: boolean = true;
    ScheduleDelete: boolean = true;
}

